// Conversões puras da resposta da API para os tipos do cadastro (sem React nem rede, para testar sozinhas).
import { dayOf } from '../format'
import type { CityStats, DefaultInfo, DefaultOpt, RecentSpecial } from '../types'

export const toList = (res: any): any[] => (Array.isArray(res?.data) ? res.data : [])
export const num = (v: unknown) => {
  const n = Number(v)
  return Number.isFinite(n) ? n : 0
}

/**
 * Desconto da API -> Padrão em vigor: o maior desconto de cada combustível (em centavos) e todas as opções dele,
 * cada uma com o custo em pontos. Custo em Dotz não é ponto do app: vale como grátis na prévia.
 */
export const toDefaultInfo = (d: any): DefaultInfo => {
  const values: Record<string, number> = {}
  const opts: Record<string, DefaultOpt[]> = {}
  ;(d.fuelDiscounts || []).forEach((f: any) => {
    const cents = Math.round(num(f.alterPriceValue) * 100)
    if (!f.fuelId || cents <= 0) return
    values[f.fuelId] = Math.max(values[f.fuelId] || 0, cents)
    const pts = (f.costValueType ?? 'points') === 'points' ? Math.max(0, Math.round(num(f.costValue))) : 0
    ;(opts[f.fuelId] = opts[f.fuelId] || []).push({ cents, pts })
  })
  return {
    id: d.id,
    code: d.identify,
    stationIds: Array.from(new Set<string>((d.placeDiscounts || []).map((p: any) => p.placeId).filter(Boolean))),
    values,
    opts,
  }
}

/** Resposta de GET /chains/{id}/customer-city-stats -> contas do cadastro de cidade. */
export const toCityStats = (res: any): CityStats => {
  const data = res?.data ?? {}
  const cities: Record<string, number> = {}
  ;(Array.isArray(data.cities) ? data.cities : []).forEach((row: any) => { if (row?.cityId) cities[String(row.cityId)] = num(row.count) })
  return { total: num(data.total), withCity: num(data.withCity), cities }
}

export const toRecent = (d: any): RecentSpecial => ({
  code: d.identify,
  name: d.description || d.identify,
  createdAt: d.createdAt,
  stationIds: (d.placeDiscounts || []).map((p: any) => p.placeId),
  fuelIds: Array.from(new Set<string>((d.fuelDiscounts || []).map((f: any) => f.fuelId))),
  // o backend guarda 23:59:59-03:00, que em UTC já é o dia seguinte: converte para o dia de Brasília
  startDate: dayOf(d.startAt) || null,
  endDate: dayOf(d.endAt) || null,
})

